import Box from '@mui/material/Box'
import type { ReactNode } from 'react'

/** Figma 6074:13368 outer panel + 6074:13375 content area padding. */
const PANEL_BORDER = '#e1e7f3'

export const QUESTION_BANK_GRID_GAP_PX = 24

type Props = Readonly<{
  children: ReactNode
  testId?: string
}>

export function QuestionBankContentPanel({ children, testId = 'question-bank-content-panel' }: Props) {
  return (
    <Box
      data-testid={testId}
      sx={{
        bgcolor: '#fff',
        border: `1px solid ${PANEL_BORDER}`,
        borderRadius: '10px',
        width: '100%',
        boxSizing: 'border-box',
        pt: '32px',
        px: '24px',
        pb: '24px',
      }}
    >
      {children}
    </Box>
  )
}

export const questionBankGridSx = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
  gap: `${QUESTION_BANK_GRID_GAP_PX}px`,
} as const
